import { render } from "./MessageFile.vue?vue&type=template&id=6f11a058&scoped=true"
import script from "./MessageFile.vue?vue&type=script&lang=js"
export * from "./MessageFile.vue?vue&type=script&lang=js"

import "./MessageFile.vue?vue&type=style&index=0&id=6f11a058&lang=scss&scoped=true"

import exportComponent from "/var/www/widget.surveybot.me/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f11a058"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
